const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      padding: 0,
      borderRadius: 0,
    },
    input: {
      height: '16px',
      backgroundColor: 'white',
      borderRadius: 0,
      padding: '8px 12px !important',
    },
    multiline: {
      padding: 0,
    },
  },
};

export default MuiOutlinedInput;
